import { App } from 'vue';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';

import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import AutoComplete from 'primevue/autocomplete';
import Badge from 'primevue/badge';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Card from 'primevue/card';
import Checkbox from 'primevue/checkbox';
import Chip from 'primevue/chip';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import DataView from 'primevue/dataview';
import Dialog from "primevue/dialog";
import Divider from 'primevue/divider';
import Dropdown from "primevue/dropdown";
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputMask from 'primevue/inputmask';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import InputText from 'primevue/inputtext';
import MegaMenu from 'primevue/megamenu';
import Menu from 'primevue/menu';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import MultiSelect from 'primevue/multiselect';
import Panel from 'primevue/panel';
import PanelMenu from 'primevue/panelmenu';
import ProgressSpinner from 'primevue/progressspinner';
import RadioButton from 'primevue/radiobutton';
import SelectButton from 'primevue/selectbutton';
import SideBar from 'primevue/sidebar';
import Steps from 'primevue/steps';
import TabPanel from 'primevue/tabpanel';
import TabView from 'primevue/tabview';
import Tag from 'primevue/tag';
import TextArea from 'primevue/textarea';
import Toast from 'primevue/toast';
import ToggleButton from "primevue/togglebutton";
import Toolbar from 'primevue/toolbar';
import Tooltip from 'primevue/tooltip';

import 'primeicons/primeicons.css';
import 'primevue/resources/themes/md-light-indigo/theme.css';
import 'primevue/resources/primevue.min.css';

export default function configurePrimeVue(app: App) {
    app.use(PrimeVue);
    app.use(ToastService);
    
    app.component('PAccordion', Accordion);
    app.component('PAccordionTab', AccordionTab);
    app.component('PAutoComplete', AutoComplete);
    app.component('PBadge', Badge);
    app.component('PButton', Button);
    app.component('PCalendar', Calendar);
    app.component('PCard', Card);
    app.component('PCheckbox', Checkbox);
    app.component('PChip', Chip);
    app.component('PColumn', Column);
    app.component('PDataTable', DataTable);
    app.component('PDataView', DataView);
    app.component('PDialog', Dialog);
    app.component('PDivider', Divider);
    app.component('PDropdown', Dropdown);
    app.component('PIconField', IconField);
    app.component('PInputIcon', InputIcon);
    app.component('PInputMask', InputMask);
    app.component('PInputNumber', InputNumber);
    app.component('PInputSwitch', InputSwitch);
    app.component('PInputText', InputText);
    app.component('PMegaMenu', MegaMenu);
    app.component('PMenu', Menu);
    app.component('PMenubar', Menubar);
    app.component('PMessage', Message);
    app.component('PMultiSelect', MultiSelect);
    app.component('PPanel', Panel);
    app.component('PPanelMenu', PanelMenu);
    app.component('PProgressSpinner', ProgressSpinner);
    app.component('PRadioButton', RadioButton);
    app.component('PSelectButton', SelectButton);
    app.component('PSideBar', SideBar);
    app.component('PSteps', Steps);
    app.component('PTabPanel', TabPanel);
    app.component('PTabView', TabView);
    app.component('PTag', Tag);
    app.component('PTextArea', TextArea);
    app.component('PToast', Toast);
    app.component('PToggleButton', ToggleButton);
    app.component('PToolbar', Toolbar);
    
    app.directive('tooltip', Tooltip);
}

// TODO: Remove with framework upgrades.
// This works around an elusive issue in Chrome/Edge where dropdown panels with filter inputs don't render until their DOM is further manipulated
export function applyDropdownPanelHack(isDropdown: boolean = false) {
    const panel = document.querySelector(isDropdown ? '.p-dropdown-panel' : '.p-multiselect-panel') as HTMLElement | undefined;
    if (!panel) return;
    // We could modify any style attribute, but this is unlikely to cause any style issues
    setTimeout(() => {
        panel.style.zIndex = parseInt(panel.style.zIndex || '999') + 1 + '';
        panel.querySelector('input')?.focus();

    }, 1)
}